export const environment = {
  production: false,
  development: true,
  staging: false,
  apiUrl: 'https://dev-api.stargallery.org',
  frontendUrl: 'https://dev.stargallery.org',
  //apiUrl: 'http://localhost:3001',
  apiVersion: 'v1'
};
